import React, { PropsWithChildren } from "react";
import { Grid } from "@material-ui/core";

export const TemplateGridItem = (props: PropsWithChildren<any>) => (
  <Grid item xs={12} md={6}>
    {props.children}
  </Grid>
);
